/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { AssertionError, buildUrl, getExternalUrl } from '@/utils/typed';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class SSOProvider {
    id;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id) {
        this.id = id;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static privateloginUrl(id, netloc) {
        return buildUrl(['api', 'sso', 'saml2', 'login', id], {
            host: netloc,
            protocol: 'https:',
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get loginUrl() {
        return SSOProvider.privateloginUrl(this.id, window.location.host);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static loginUrlFromTenant(tenant) {
        AssertionError.assert(tenant.ssoProviderId.isJust());
        return SSOProvider.privateloginUrl(tenant.ssoProviderId.extract(), tenant.netloc);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
class Saml2Provider extends SSOProvider {
    idpMetadataUrl;
    name;
    description;
    logo;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, idpMetadataUrl, name, description, logo) {
        super(id);
        this.idpMetadataUrl = idpMetadataUrl;
        this.name = name;
        this.description = description;
        this.logo = logo;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new Saml2Provider(data.id, data.metadata_url, data.ui_info.name, data.ui_info.description, data.ui_info.logo);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get metadataUrl() {
        return buildUrl(['api', 'sso', 'saml2', 'metadata', this.id], {
            baseUrl: getExternalUrl(),
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get logoUrl() {
        if (this.logo != null) {
            return this.logo.url;
        }
        return buildUrl(['api', 'v1', 'sso_providers', this.id, 'default_logo']);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeSSOProvider(data) {
    return Saml2Provider.fromServerData(data);
}
